import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { FeedbackDialog } from "./FeedbackDialog";

/**
 * FeedbackButton
 * Floating action button rendered in the upper-right of authenticated pages.
 * Owns the feedback dialog's open state.
 * Last Updated Date: July 16, 2026
 * @author Jette  
 */
export const FeedbackButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsDialogOpen(true)}
        aria-label="Send feedback"
        title="Send feedback"
        className="fixed top-20 right-4 sm:right-6 z-50 flex items-center gap-2 rounded-full bg-brand px-4 py-2.5 text-sm font-medium text-white shadow-lg transition-colors hover:bg-brand/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
      >
        <MessageSquarePlus className="h-4 w-4" />
        <span className="hidden sm:inline">Feedback</span>
      </button>

      <FeedbackDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </>
  );
};
